// src/components/Pagination/context.ts
import { createContext } from "react";
var PaginationContext = createContext({
  total: 1,
  perPage: 10,
  siblingPages: 2,
  currentPage: 1,
  pages: [1],
  totalPages: 1
});
export { PaginationContext };